<template>
  <div class="detail-workspace">
    <section class="detail-workspace__hero" v-loading="Loading">
      <div class="detail-workspace__logo">
        <img v-if="appDetail.logo" :src="appDetail.logo" alt="商品 Logo" />
        <div v-else class="detail-workspace__logo-fallback">PD</div>
      </div>
      <div class="detail-workspace__content">
        <span class="detail-workspace__eyebrow">Product Detail</span>
        <div class="detail-workspace__title-row">
          <h2 class="detail-workspace__title">
            {{ appDetail.name || '商品详情' }}
          </h2>
          <span class="detail-workspace__badge">商品管理</span>
        </div>
        <p class="detail-workspace__desc">{{ summaryText }}</p>
        <div class="detail-workspace__meta">
          <span class="detail-workspace__chip"><strong>ID</strong>{{ productID }}</span>
          <span class="detail-workspace__chip"><strong>当前分区</strong>{{ activeLabel }}</span>
          <span class="detail-workspace__chip"><strong>组织</strong>{{ appDetail.organizationID || '-' }}</span>
        </div>
      </div>
    </section>

    <el-tabs class="customTabs" v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="基础信息" name="detail" v-if="baseInfo" key="1">
        <div class="detail-workspace__pane">
          <basic-info
            :marketID="marketID"
            :Loading="Loading"
            :appDetail="appDetail"
          ></basic-info>
        </div>
      </el-tab-pane>
      <el-tab-pane label="套餐管理" name="packages" key="2">
        <div class="detail-workspace__pane">
          <app-package
            :marketID="marketID"
            :Loading="Loading"
            :appDetail="appDetail"
          ></app-package>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { errorHandle } from '@/utils/error';
import AppPackage from '../components/appPackage';
import BasicInfo from '../components/basicInfo';

export default {
  name: 'ProductDetail',
  components: { BasicInfo, AppPackage },

  data() {
    return {
      activeName: this.$route.params.tabMode
        ? this.$route.params.tabMode
        : 'detail',
      appDetail: {},
      productID: this.$route.params.productID,
      Loading: true
    };
  },
  created() {
    this.fetchProductInfo();
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    baseInfo() {
      return true;
    },
    activeLabel() {
      const map = {
        detail: '基础信息',
        packages: '套餐管理'
      };
      return map[this.activeName] || '详情';
    },
    summaryText() {
      const raw =
        this.appDetail.introduction ||
        this.appDetail.description ||
        '在这里管理商品基础资料、展示信息与套餐配置。';
      return String(raw)
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 120);
    }
  },
  methods: {
    fetchProductInfo() {
      this.Loading = true;
      this.$store
        .dispatch('GetProductDetail', {
          marketID: this.marketID,
          productID: this.productID
        })
        .then((res) => {
          this.Loading = false;
          this.appDetail = res;
          this.appDetail.initSuccess = true;
        })
        .catch((err) => {
          this.Loading = false;
          errorHandle(err);
          if (err.code == 404 || err.code == 40404) {
            this.$message.error('商品不存在');
            this.$router.push({
              name: 'productManage'
            });
          }
        });
    },
    handleClick(tab) {
      this.activeName = tab.name;
      this.$router.push({
        name: 'StoreProductManageDetails',
        params: { tabMode: tab.name, productID: this.productID }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/detail-workspace.scss';
</style>



// WEBPACK FOOTER //
// src/views/storeManage/productManage/productDetail/index.vue